import PrimaryButton from "../../components/button";

import DataTable from "../../components/dataTable";

import DeleteIcon from '@mui/icons-material/Delete';

import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';

import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import NoticeModal from "../../components/noticeModal";

import EditIcon from '@mui/icons-material/Edit';

import VisibilityIcon from '@mui/icons-material/Visibility';

import CreateMenuItemModal from "./CreateMenuItemModal";

import ViewMenuItemModal from "./ViewMenuItemModal";

import Pagination from "../../components/pagination";

import CreateCategoryModal from "./CreateCategoryModal";

import ViewCategoriesModal from "./ViewCategoriesModal";

import SearchBar from "../../components/searchContainer";

import { addMenuWarning } from '../reports';

import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { getMenuImageUrl } from "../../utils/menuImageUrl";

import {

  useFetchMenuItemsQuery,

  useDeleteMenuItemMutation,

  useFetchDeletedMenuItemsQuery,

  useRestoreMenuItemMutation,

} from "../../api";



const Menu = () => {

  const navigate = useNavigate();

  const [isTrash, setIsTrash] = useState(false);

  const activeQuery = useFetchMenuItemsQuery('', {
    skip: isTrash,
    refetchOnMountOrArgChange: true,
  });

  const trashQuery = useFetchDeletedMenuItemsQuery(undefined, {
    skip: !isTrash,
    refetchOnMountOrArgChange: true,
  });



  const { data, isLoading, isError } = isTrash ? trashQuery : activeQuery;



  const [deleteMenuItem, { isLoading: deleteLoader }] = useDeleteMenuItemMutation();

  const [restoreMenuItem, { isLoading: restoreLoader }] = useRestoreMenuItemMutation();

  const [menuItemModal, setMenuItemModal] = useState(false);

  const [deleteModal, setDeleteModal] = useState(false);

  const [details, setDetails] = useState<any>({});

  const [viewMenuItemModal, setViewMenuItemModal] = useState(false);

  const [page, setPage] = useState(1);

  const pageSize = 10;

  const [createCategoryModal, setCreateCategoryModal] = useState(false);

  const [viewCategoriesModal, setViewCategoriesModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState({ type: 'name', value: '' });

  const [filteredData, setFilteredData] = useState<any[]>([]);



  // Filter data based on search query

  useEffect(() => {

    if (!data) return;



    const items = Array.isArray(data) ? data : [];



    if (!searchQuery.value.trim()) {

      setFilteredData(items);

      return;

    }

    const searchTerm = searchQuery.value.toLowerCase();

    const filtered = items.filter(item => {

      const remaining = Math.max(0, (item.stockQuantity || 0) - (item.soldQuantity || 0) - (item.givenQuantity || 0));
      const status = remaining > 0 && item.isAvailable ? 'available' : 'not available';

      switch (searchQuery.type) {

        case 'mainCategory':

          return (item.categoryId?.type || item.type || '').toLowerCase().includes(searchTerm);

        case 'subCategory':

          return (item.categoryId?.name || 'Uncategorized').toLowerCase().includes(searchTerm);

        case 'name':

          return (item.deviceName || '').toLowerCase().includes(searchTerm);

        case 'price':

          return String(item.price || '').toLowerCase().includes(searchTerm);

        case 'stock':

          return `${remaining} available`.toLowerCase().includes(searchTerm);

        case 'status':

          return status.includes(searchTerm);

        default:

          return false;

      }

    });



    setFilteredData(filtered);

    setPage(1); // Reset to first page on new search

  }, [data, searchQuery]);



  // Handle search with debounce for better performance

  const handleSearch = (searchParams: { type: string; value: string }) => {

    setSearchQuery(prev => ({

      ...prev,

      ...searchParams

    }));

  };



  const searchOptions = [

    { label: 'Main Category', value: 'mainCategory' },

    { label: 'Sub Category', value: 'subCategory' },

    { label: 'Item Name', value: 'name' },

    { label: 'Price', value: 'price' },

    { label: 'Stock', value: 'stock' },

    { label: 'Status', value: 'status' }

  ];





  const tableHeaders = [

    {

      label: 'Item Image',

      value: 'image'

    },

    { label: 'Main Category', value: 'mainCategory' },

    { label: 'Sub Category', value: 'category' },

    { label: 'Item Name', value: 'name' },

    { label: 'Price', value: 'displayPrice' },

    { label: 'Stock', value: 'stock' },

    { label: 'Status', value: 'status' },

    { label: 'Actions', value: 'actions', isAction: true }

  ];



  const menuItemsToDisplay = searchQuery.value.trim() ? filteredData : (Array.isArray(data) ? data : []);

  const formatMenuItems = menuItemsToDisplay?.map((item: any, index: number) => ({

    // Don't spread the entire item to avoid duplicate properties

    id: item._id || item.id || `item-${index}`,

    _id: item._id,

    type: item.type,

    deviceName: item.deviceName,

    price: item.price, // Keep original price

    description: item.description,

    ingredients: item.ingredients,

    preparationTime: item.preparationTime,

    isAvailable: item.isAvailable,

    images: item.images,

    createdAt: item.createdAt,

    updatedAt: item.updatedAt,



    // Table display properties

    image: item?.images?.[0]?.url ? (

      <img

        key={`image-${item._id || index}`}

        src={getMenuImageUrl(item.images[0]?.url)}

        alt={item.deviceName}

        style={{

          width: 100,

          height: 80,

          objectFit: 'cover',

          borderRadius: '8px',

          border: '1px solid #e5e5e5',

          cursor: 'pointer'

        }}

        onClick={() => navigate(`/menu/items/${item._id}`)}

        title="Click to view transactions"

      />

    ) : (

      <div

        key={`image-${item._id || index}`}

        style={{

          width: 100,

          height: 80,

          borderRadius: '8px',

          backgroundColor: '#f5f5f5',

          border: '1px solid #e5e5e5',

          display: 'flex',

          alignItems: 'center',

          justifyContent: 'center',

          color: '#999',

          fontSize: '12px',

          cursor: 'pointer'

        }}

        onClick={() => navigate(`/menu/items/${item._id}`)}

        title="Click to view transactions"

      >

        No Image

      </div>

    ),

    mainCategory: (() => {

      const ctype = item.categoryId?.type || item.type || 'Other';

      return (

        <span

          key={`main-cat-${item._id || index}`}

          className={`badge bg-${ctype === 'Snacks' ? 'warning' : ctype === 'Drinks' ? 'primary' : 'secondary'}`}

          style={{

            padding: '4px 10px',

            borderRadius: '20px',

            fontSize: '0.7rem',

            fontWeight: 600,

            textTransform: 'uppercase',

            color: ctype === 'Snacks' ? '#000' : '#fff',

            display: 'inline-block'

          }}

        >

          {ctype}

        </span>

      );

    })(),

    category: (

      <span

        key={`category-${item._id || index}`}

        style={{ cursor: 'pointer' }}

        onClick={() => navigate(`/menu/items/${item._id}`)}

        title="Click to view transactions"

      >

        {item.categoryId?.name || 'Uncategorized'}

      </span>

    ),

    name: (

      <span

        key={`name-${item._id || index}`}

        style={{ cursor: 'pointer', fontWeight: '500' }}

        onClick={() => navigate(`/menu/items/${item._id}`)}

        title="Click to view transactions"

      >

        {item.deviceName}

      </span>

    ),

    displayPrice: `${item.price} Rwf`,

    stock: (() => {

      const remaining = Math.max(0, (item.stockQuantity || 0) - (item.soldQuantity || 0) - (item.givenQuantity || 0));

      return (

        <div key={`stock-${item._id || index}`} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span
            style={{
              padding: '2px 8px',
              borderRadius: '6px',
              backgroundColor: remaining === 0 ? '#fee2e2' : remaining < 10 ? '#ffedd5' : '#ecfdf5',
              color: remaining === 0 ? '#ef4444' : remaining < 10 ? '#f97316' : '#10b981',
              fontWeight: '700',
              fontSize: '12px',
              display: 'inline-block',
              width: 'max-content'
            }}
          >
            {remaining} available
          </span>

        </div>

      );

    })(),

    status: (() => {

      const remaining = Math.max(0, (item.stockQuantity || 0) - (item.soldQuantity || 0) - (item.givenQuantity || 0));

      const available = remaining > 0 && item.isAvailable;



      const statusBadge = available ? (

        <span key={`status-${item._id || index}`} className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium inline-block">

          Available

        </span>

      ) : (

        <span key={`status-${item._id || index}`} className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs font-medium inline-block">

          Not Available

        </span>

      );



      if (isTrash && item.deletedAt) {

        const deletedDate = new Date(item.deletedAt);

        const autoDeleteDate = new Date(deletedDate.getTime() + 14 * 24 * 60 * 60 * 1000);

        const daysLeft = Math.ceil((autoDeleteDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));

        const daysAgo = Math.max(0, 14 - daysLeft);



        return (

          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>

            {statusBadge}

            <span style={{ fontSize: '10px', color: daysLeft <= 3 ? '#ef4444' : '#6b7280', fontWeight: '500', backgroundColor: daysLeft <= 3 ? '#fee2e2' : '#f3f4f6', padding: '2px 6px', borderRadius: '4px' }}>

              Deletes in {Math.max(0, daysLeft)} days

            </span>

          </div>

        );

      }



      return statusBadge;

    })(),

    actions: (

      <div key={`actions-${item._id || index}`} className="flex items-center gap-4">

        {isTrash ? (

          <>

            <div title="Restore Item">

              <RestoreFromTrashIcon

                style={{ cursor: 'pointer', color: '#10b981' }}

                onClick={() => handleRestoreMenuItem(item)}

              />

            </div>

          </>

        ) : (

          <>

            <div title="View Details">

              <VisibilityIcon

                style={{ cursor: 'pointer', color: '#000' }}

                onClick={() => {

                  setViewMenuItemModal(true);

                  setDetails(item);

                }}

              />

            </div>

            <div title="Edit Item">

              <EditIcon

                style={{ cursor: 'pointer', color: '#000' }}

                onClick={() => {

                  setMenuItemModal(true);

                  setDetails(item);

                }}

              />

            </div>

            <div title="Delete Item">

              <DeleteIcon

                style={{ cursor: 'pointer', color: '#FF0000' }}

                onClick={() => {

                  setDeleteModal(true);

                  setDetails(item);

                }}

              />

            </div>

          </>

        )}

      </div>

    )

  }));



  const pagedItems = formatMenuItems.slice((page - 1) * pageSize, page * pageSize);



  const handleAddMenuItem = () => {

    setDetails({});

    setMenuItemModal(true);

  };



  const handleDeleteMenuItem = () => {

    if (details._id) {

      // Calculate detailed data before deleting

      const deletedData = {

        soldQuantity: details.soldQuantity || 0,

        givenQuantity: details.givenQuantity || 0,

        totalStock: details.stockQuantity || 0,

        soldMoney: (details.soldQuantity || 0) * (details.price || 0),

        stockRemaining: (details.stockQuantity || 0) - (details.soldQuantity || 0) - (details.givenQuantity || 0)

      };



      deleteMenuItem(details._id)

        .then(() => {

          // Add warning message to reports with detailed data

          addMenuWarning(details.deviceName, deletedData);

          setDeleteModal(false);

          setDetails({});

        })

        .catch((error: any) => {

          console.error('Error deleting menu item:', error);

          toast.error('Error deleting menu item. Please try again.');

        });

    }

  };



  const handleRestoreMenuItem = (item: any) => {

    restoreMenuItem(item._id)

      .then(() => {

        toast.success(`${item.deviceName} restored successfully`);

      })

      .catch((err) => {

        console.error('Error restoring menu item:', err);

        toast.error('Failed to restore menu item');

      });

  };





  if (isError) {

    return (

      <div className="page-content-container">

        <div className="text-center py-8">

          <p className="text-red-500 text-lg">Error loading menu items</p>

          <p className="text-gray-400">Please check if the backend server is running</p>

        </div>

      </div>

    );

  }



  return (

    <div className="page-content-container">



      <div className="right-button-container">

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 12 }}>

          <PrimaryButton

            label={isTrash ? "View Active Items" : "View Trash"}

            onClick={() => setIsTrash(!isTrash)}

            fullWidth={false}

          />

          {!isTrash && (

            <>

              <PrimaryButton

                label="Add Menu Item"

                onClick={handleAddMenuItem}

                fullWidth={false}

              />

              <PrimaryButton

                label="Create Category"

                onClick={() => setCreateCategoryModal(true)}

                fullWidth={false}

              />

            </>

          )}

        </div>

      </div>



      <div className="table-content-container">

        {isLoading ? (

          <div className="text-center py-8">

            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>

            <p className="text-gray-500 text-lg mt-4">Loading menu items...</p>

          </div>

        ) : (Array.isArray(data) && data.length === 0) ? (

          <div className="text-center py-8">

            <div className="text-gray-400 text-6xl mb-4">🍕</div>

            <p className="text-gray-500 text-lg">No menu items yet</p>

            <p className="text-gray-400 mt-2">Click "Add Menu Item" to create your first menu item</p>

          </div>

        ) : (

          <>

            <div className="mb-4 w-full max-w-2xl">

              <SearchBar

                onSearch={handleSearch}

                menuItems={searchOptions}

              />

            </div>

            {filteredData.length === 0 && searchQuery.value && (

              <div className="text-center py-8">

                <p className="text-gray-500 text-lg">No items found matching your search.</p>

              </div>

            )}

            <DataTable

              headers={tableHeaders}

              data={pagedItems}

              isLoading={isLoading}

            />

            <Pagination

              page={page}

              onPageChange={(type: string) => setPage(prev => {

                const max = Math.max(1, Math.ceil(formatMenuItems.length / pageSize));

                return type === 'next' ? Math.min(max, prev + 1) : Math.max(1, prev - 1);

              })}

            />

          </>

        )}

      </div>



      {menuItemModal && (

        <CreateMenuItemModal

          show={menuItemModal}

          hide={() => setMenuItemModal(false)}

          details={details}

          setDetails={setDetails}

        />

      )}



      <NoticeModal

        show={deleteModal}

        hide={() => setDeleteModal(false)}

        text="Delete this menu item"

        subText="Are you sure you want to delete this menu item? It will be moved to the trash and can be restored later."

        handleDelete={handleDeleteMenuItem}

        isLoading={deleteLoader}

      />



      {viewMenuItemModal && (

        <ViewMenuItemModal

          show={viewMenuItemModal}

          hide={() => setViewMenuItemModal(false)}

          details={details}

        />

      )}



      {createCategoryModal && (

        <CreateCategoryModal

          show={createCategoryModal}

          hide={() => setCreateCategoryModal(false)}

        />

      )}



      {viewCategoriesModal && (

        <ViewCategoriesModal

          show={viewCategoriesModal}

          hide={() => setViewCategoriesModal(false)}

        />

      )}

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar theme="colored" />

    </div>

  );

};



export default Menu;

